export default __webpack_public_path__ + "static/media/vinho1.b4d9722d.jpg";